const getters = {
  sidebar: state => state.app.sidebar,
  addRouters: state => state.permission.addRouters,
  username: state => state.user.name,
  avatar: state => state.user.avatar,
  roleId: state => state.user.roleId,
  email: state => state.user.email,
  userId: state => state.user.id,
  token: state => state.user.token,
  userFunction: state => state.user.userFunction,
  userMenu: state => state.user.userMenu,
  permissionRouters: state => state.permission.routers,
  errorLogs: state => state.errorLog.logs,
  monitorProjectInfo: state => state.app.monitorProjectInfo,
  screenWidth: state => state.user.screenWidth
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js